import {getNonEmptyStringErrors} from 'Core/models/EmptyString';
import {
  changeAddressCity,
  changeAddressFirstName,
  changeAddressLastName,
  changeAddressMiddleName,
  changeAddressState,
  changeAddressStreet,
  changeAddressZip,
} from 'Agent/Policies/ducks/policyServiceRequest';
import {AddressChangeRequest} from 'Agent/Policies/models/ServiceRequest/AddressChangeRequest';
import React from 'react';
import {useDispatch} from 'react-redux';
import {compose} from 'redux';
import ValidatableTextField from 'Shared/components/ValidatableTextField';

type AddressChangeRequestProps = {
  addressChangeRequest: AddressChangeRequest;
};

const AddressChangeRequestForm = (props: AddressChangeRequestProps) => {
  const dispatch = useDispatch();
  const {addressChangeRequest} = props;

  return (
    <div className="service-request-form__section">
      <ValidatableTextField
        label="First Name"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(addressChangeRequest.firstName)}
        onChange={compose(dispatch, changeAddressFirstName)}
        value={addressChangeRequest.firstName.value}
      />
      <ValidatableTextField
        label="Middle Name"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(addressChangeRequest.middleName)}
        onChange={compose(dispatch, changeAddressMiddleName)}
        value={addressChangeRequest.middleName.value}
      />
      <ValidatableTextField
        label="Last Name"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(addressChangeRequest.lastName)}
        onChange={compose(dispatch, changeAddressLastName)}
        value={addressChangeRequest.lastName.value}
      />
      <ValidatableTextField
        label="Street"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(addressChangeRequest.street)}
        onChange={compose(dispatch, changeAddressStreet)}
        value={addressChangeRequest.street.value}
      />
      <ValidatableTextField
        label="City"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(addressChangeRequest.city)}
        onChange={compose(dispatch, changeAddressCity)}
        value={addressChangeRequest.city.value}
      />
      <ValidatableTextField
        label="State"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(addressChangeRequest.state)}
        onChange={compose(dispatch, changeAddressState)}
        value={addressChangeRequest.state.value}
      />
      <ValidatableTextField
        label="Zip"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(addressChangeRequest.zip)}
        onChange={compose(dispatch, changeAddressZip)}
        value={addressChangeRequest.zip.value}
      />
    </div>
  );
};

export default AddressChangeRequestForm;
